import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components/macro";
import { ArrowLeft } from "react-feather";
import { get } from "lodash";

import ModelSelectorContext from "../../context/modelSelector/Context";

const ButtonContainer = styled.div`
    bottom: 25px;
    top: auto;
    left: 40px;
    position: absolute;
    cursor: pointer;
    color: white;
    z-index: 2;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 14px;
    @media (min-width: 2561px) {
        transform: scale(1.85, 1.85);
        transform-origin: bottom left;
    }
`;
const IconContainer = styled.div`
    ${({ theme }: { theme: any }) =>
        get(theme, "buttonBack.mode", "secondary") === "secondary"
            ? `background: rgba(255,255,255, 0.6); ${theme.buttonBack?.backgroundColor};`
            : `background: ${theme.buttonBack?.backgroundColor}; border: none;`}
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 10px 0 rgba(0, 0, 0, 0.2);
    &:hover {
        ${({ theme }: { theme: any }) =>
            theme.buttonBack?.mode === "secondary"
                ? `background: rgba(255,255,255, 0.7);`
                : `background: ${theme.buttonBack?.hoverColor};`}
    }
    &:active {
        ${({ theme }: { theme: any }) =>
            theme.buttonBack?.mode === "secondary"
                ? `background: rgba(255,255,255, 0.8);`
                : `background: ${theme.buttonBack?.activeColor};`}
    }
`;

const Text = styled.div`
    text-shadow: #000 0px 1px 12px;
    padding-top: 10px;
    text-align: center;
`;

export const ModelSelectorButtonBack = ({ onClick }: { onClick: () => void }) => {
    const appContext = useContext(ModelSelectorContext);
    const theme = useContext(ThemeContext);

    const { translatedTexts } = appContext;

    return (
        <ButtonContainer onClick={() => onClick()}>
            <IconContainer>
                <ArrowLeft
                    color={
                        get(theme, "buttonBack.mode", "secondary") === "secondary"
                            ? get(theme, "buttonBack.backgroundColor", "var(--primary-color)")
                            : "white"
                    }
                />
            </IconContainer>
            <Text>{get(translatedTexts, "back")}</Text>
        </ButtonContainer>
    );
};
